import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import type { SupportedModules } from '../providers/FeatureFlag.provider';
import { DEFAULT_MODULE } from '../constants';

const useActiveModule = (): { activeModule: SupportedModules } => {
  const { pathname } = useLocation();
  const [activeModule, setActiveModule] = useState<SupportedModules>('dashboard');
  const [, moduleName] = pathname.split('/');

  useEffect(() => {
    const pathModuleMap: { [key: string]: SupportedModules } = {
      accounts: 'accounts',
      dashboard: 'dashboard',
      partners: 'partners',
      'partners-create': 'partners',
      'billing-packages': 'billingPackages',
      reports: 'reports',
      'account-activity': 'reports',
      // Old Invoices/Statements links now resolve to the Account & Billing module, which redirects
      // them to /account-and-billing (see AccountBilling/Routes). ID-13148 retired the standalone page.
      statements: 'accountBilling',
      invoices: 'accountBilling',
      'account-and-billing': 'accountBilling',
      leads: 'leads',
      'leads-create': 'leads',
      'accounts-create': 'accounts',
      'billing-packages-create': 'billingPackages',
      users: 'users',
      support: 'support',
      tickets: 'support',
      faq: 'support',
      'tickets-create': 'support',
      'learning-centre': 'support',
      transactions: 'transactions',
      settings: 'settings',
      'partner-account-transactions': 'transactions',
      'partner-account-transfers': 'transactions',
      'onboarding-form-tracker': 'onBoardingFormTracker',
      reconciliation: 'reports',
    };

    setActiveModule(pathModuleMap[moduleName] || DEFAULT_MODULE);
  }, [pathname]);

  return { activeModule };
};

export default useActiveModule;
